var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49998 12.4154C9.49152 12.4154 11.9166 9.99024 11.9166 6.9987C11.9166 4.00716 9.49152 1.58203 6.49998 1.58203C3.50844 1.58203 1.08331 4.00716 1.08331 6.9987C1.08331 9.99024 3.50844 12.4154 6.49998 12.4154Z",
    stroke: "#0F0F0F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33335 2.125H4.87501C3.81876 5.28833 3.81876 8.71167 4.87501 11.875H4.33335",
    stroke: "#0F0F0F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 2.125C9.18125 5.28833 9.18125 8.71167 8.125 11.875",
    stroke: "#0F0F0F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 9.16667V8.625C4.78833 9.68125 8.21167 9.68125 11.375 8.625V9.16667",
    stroke: "#0F0F0F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 5.37422C4.78833 4.31797 8.21167 4.31797 11.375 5.37422",
    stroke: "#0F0F0F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.68e7aafd4110ce9b4ce0b1de8a0103da.svg";
export { ForwardRef as ReactComponent };